/** Keeps embed links on WordPress while the Börse API changes its base path. */
export function getBoerseWebsiteUrl(path: string): string {
  return `https://wp.fuw.ch/boerse${path.replace(/^\/boerse(?=\/|[?#]|$)/, "")}`
}
